// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useState } from "react";

import { mdiGrid } from "@mdi/js";
import { Popover } from "antd";

import { ToolbarButton } from "components/base";

import { useXdaSettingsStore } from "../../context";
import {
  selectShowGrid,
  selectShowRelativeDepth,
  selectShowTVDSSDepth
} from "../../context/xdaSettingsSelectors";
import XdaGridOptions from "./XdaGridOptions";

function XdaGridToggle() {
  const [visible, setVisible] = useState(false);
  const showGrid = useXdaSettingsStore(selectShowGrid);
  const showRelativeDepth = useXdaSettingsStore(selectShowRelativeDepth);
  const showTVDSSDepth = useXdaSettingsStore(selectShowTVDSSDepth);

  return (
    <Popover
      content={<XdaGridOptions />}
      open={visible}
      onOpenChange={(v) => setVisible(v)}
      trigger="click"
      placement="bottomRight">
      <ToolbarButton
        icon={<Icon path={mdiGrid} size={1.5} />}
        isMenuButton={true}
        active={showGrid || showRelativeDepth || showTVDSSDepth}
        tooltipText={"Show Grid"}
        overflowLabel={"Grid Toggle"}
        styleKey="xdaToolbar"
      />
    </Popover>
  );
}

export default XdaGridToggle;
